import CircleQuestionMarkEmpty from '../../src/legacy/CircleQuestionMarkEmpty.tsx';
export default CircleQuestionMarkEmpty;
